import { forwardRef } from 'react'
import cn from 'clsx'
import { buildImageCandidates } from '../responsive-image/imageCandidates'
import { UserIcon } from '../icons'
import { Image } from '../image'
import type { TAvatarFallbackProps, TAvatarImageProps, TAvatarProps } from './Avatar.types'
import styles from './Avatar.module.css'

export const Avatar = forwardRef<HTMLSpanElement, TAvatarProps>(
    ({ className, disabled, theme = 'default', ...props }, ref) => (
        <span
            ref={ref}
            data-disabled={disabled}
            className={cn(styles.root, styles[`root-${theme}`], className)}
            {...props}
        />
    ),
)

export const AvatarImage = forwardRef<HTMLImageElement, TAvatarImageProps>(
    ({ className, src, alt, resize, priority = false, ...props }, ref) => {
        const candidates = buildImageCandidates({
            src: src ?? '',
            resize,
            width: props.sizes ? undefined : Number(props.width) || undefined,
            sizes: props.sizes,
        })

        return (
            <Image
                ref={ref}
                alt={alt}
                className={cn(styles.image, className)}
                src={candidates.src}
                srcSet={candidates.srcSet}
                loading={priority ? undefined : 'lazy'}
                fetchPriority={priority ? 'high' : undefined}
                decoding="async"
                {...props}
            />
        )
    },
)

export const AvatarFallback = forwardRef<HTMLSpanElement, TAvatarFallbackProps>(
    ({ className, children, theme = 'default', ...props }, ref) => (
        <span
            ref={ref}
            className={cn(styles.fallback, styles[`fallback-${theme}`], className)}
            {...props}
        >
            {children ?? <UserIcon className={styles.userIcon} />}
        </span>
    ),
)
